"use client";

import { FC, memo } from "react";
import {
  Color,
  colorClassMap,
} from "apps/website/components/base/Text/Text.map";
import cx from "apps/website/utils/misc/cx";

import * as IllustrationMap from "./illustration.map";

export interface IIllustration {
  size?: IllustrationMap.Size;
  color?: Color;
  illustration: IllustrationMap.IllustrationSvg;
  className?: string;
  ariaHidden?: boolean
}

const Illustration: FC<IIllustration> = ({
  size = "fit",
  color = "default",
  illustration,
  className,
  ariaHidden = false,
}) => {
  const sizeClass = IllustrationMap.illustrationSizeClassMap[size];
  const computedClasses = cx(sizeClass, colorClassMap[color], className);
  const IllustrationComponent = IllustrationMap.illustrationSvgMap[illustration];
  return (
    <div
      data-component={Illustration.name}
      className={computedClasses}
      aria-hidden={ariaHidden}
      data-testid={`illustration-${illustration}`}
    >
      { /** @ts-ignore */ }
      <IllustrationComponent />
    </div>
  );
};

export default memo(Illustration);
